import app from 'flarum/forum/app';
import Component from 'flarum/common/Component';
import Tooltip from 'flarum/common/components/Tooltip';
import Icon from 'flarum/common/components/Icon';
import extractText from 'flarum/common/utils/extractText';
const OS_ICON = {
  Windows: 'fab fa-windows',
  macOS: 'fab fa-apple',
  Mac: 'fab fa-apple',
  iOS: 'fab fa-apple',
  iPadOS: 'fab fa-apple',
  Android: 'fab fa-android',
  Ubuntu: 'fab fa-ubuntu',
  'Chrome OS': 'fab fa-chrome',
  Linux: 'fab fa-linux',
  'GNU/Linux': 'fab fa-linux',
  BlackBerry: 'fab fa-blackberry'
};
const CLIENT_ICON = {
  Chrome: 'fab fa-chrome',
  Chromium: 'fab fa-chrome',
  'Mobile Chrome': 'fab fa-chrome',
  Edge: 'fab fa-edge',
  'Microsoft Edge': 'fab fa-edge',
  Firefox: 'fab fa-firefox-browser',
  'Mobile Firefox': 'fab fa-firefox-browser',
  Safari: 'fab fa-safari',
  'Mobile Safari': 'fab fa-safari',
  Opera: 'fab fa-opera',
  Brave: 'fas fa-shield-halved',
  'Samsung Browser': 'fas fa-globe',
  'Internet Explorer': 'fab fa-internet-explorer'
};
function osIcon(meta) {
  if (!meta || !meta.os) return 'fas fa-globe';
  return OS_ICON[meta.os.family] || OS_ICON[meta.os.name] || 'fas fa-globe';
}
function osLabel(meta) {
  if (!meta || !meta.os) return null;
  return meta.os.version ? "".concat(meta.os.name, " ").concat(meta.os.version) : meta.os.name;
}
function clientLabel(meta) {
  if (!meta || !meta.client) return null;
  return meta.client.version ? "".concat(meta.client.name, " ").concat(meta.client.version) : meta.client.name;
}
function deviceLabel(meta) {
  if (!meta || !meta.device || !meta.device.type) return null;
  const type = extractText(app.translator.trans("datlechin-posted-on.forum.device_types.".concat(meta.device.type))) || meta.device.type;
  const parts = [type];
  if (meta.device.brand && meta.device.model) {
    parts.push("".concat(meta.device.brand, " ").concat(meta.device.model));
  } else if (meta.device.brand) {
    parts.push(meta.device.brand);
  }
  return parts.join(' · ');
}
export default class PostedOn extends Component {
  view() {
    const post = this.attrs.post;
    const meta = post.postedOnMeta && post.postedOnMeta();
    const legacy = post.postedOn && post.postedOn();
    if (!meta && !legacy) return null;
    const os = osLabel(meta);
    const client = clientLabel(meta);
    const device = deviceLabel(meta);
    const mode = app.forum.attribute('postedOnDisplayMode') || 'os_only';
    let inline;
    if (meta) {
      inline = mode === 'os_browser' && client ? "".concat(os, " \xB7 ").concat(client) : os || client;
    } else {
      // Legacy posts (rendered before posted_on_meta was introduced) only
      // have the flat string, so we trust that and skip the icon lookup.
      inline = legacy;
    }
    return m(Tooltip, {
      text: this.tooltip({
        os,
        client,
        device,
        legacy
      })
    }, m("span", {
      className: "PostedOn"
    }, m(Icon, {
      name: osIcon(meta)
    }), m("span", {
      className: "PostedOn-text"
    }, inline)));
  }
  tooltip(_ref) {
    let {
      os,
      client,
      device,
      legacy
    } = _ref;
    if (!os && !client && !device) {
      return extractText(app.translator.trans('datlechin-posted-on.forum.post.posted_on_text', {
        posted_on: legacy
      }));
    }
    const lines = [];
    if (os) lines.push("".concat(extractText(app.translator.trans('datlechin-posted-on.forum.post.tooltip.os')), ": ").concat(os));
    if (client) lines.push("".concat(extractText(app.translator.trans('datlechin-posted-on.forum.post.tooltip.client')), ": ").concat(client));
    if (device) lines.push("".concat(extractText(app.translator.trans('datlechin-posted-on.forum.post.tooltip.device')), ": ").concat(device));
    return lines.join('\n');
  }
}
flarum.reg.add('datlechin-posted-on', 'forum/components/PostedOn', PostedOn);